function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import fonts from './fonts';
import borders from './borders';
import radii from './radii';
import elevation from './elevation';
import { hydro2, legacyColorPalette } from '@dfds-ui/colors';
import { spacing } from '@dfds-ui/spacing';
import states from './states';
import breakpoints from './breakpoints';
import zIndex from './z-index';

// eslint-disable-next-line deprecation/deprecation
var themeColors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, hydro2), legacyColorPalette.surface), legacyColorPalette["static"]), legacyColorPalette.interaction), legacyColorPalette.status);
var theme = _objectSpread(_objectSpread({}, fonts), {}, {
  borders: borders,
  colors: themeColors,
  spacing: spacing,
  radii: radii,
  elevation: elevation,
  breakpoints: breakpoints,
  states: states,
  zIndex: zIndex
});
export default theme;